import React from "react";
import { useWindowDimensions } from "react-native";
import RenderHtml from "react-native-render-html";

const defaultText = "<p>--</p>";

function HtmlText({ text = defaultText }) {
  const { width } = useWindowDimensions();
  const htmlTagStyles = {
    p: {
      textAlign: "center",
      color: "rgba(0, 0, 0, 0.56)",
      fontSize: 12,
    },
    span: {
      color: "#00AB59",
      fontWeight: "bold",
    },
  };
  return <RenderHtml source={{ html: `<p>${text}</p>` }} tagsStyles={htmlTagStyles} contentWidth={width} />;
}

export default HtmlText;
